export default class RouterUtils {

  static generateRoute(route, params = {}){
    let routeStr = route;
    for (let key in params) {
      routeStr = routeStr.replace(String(':' + key).trim(), String(params[key]).trim());
    }
    return routeStr;
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/routing/RouterUtils.js